(function($) {

	'use strict';

	var init = function() {
        var accordion_button_open = $('.js-accordion-toggle'),
        	accordion_button_lvl2_open = $('.js-accordion-toggle-lv2'),
        	accordion_collapse = $('.js-collapse');

        // Fisrt hide content lvl1 + lvl2
        accordion_collapse.hide();

        accordion_button_open.on('click', openAccordion);
        accordion_button_lvl2_open.on('click', openAccordionLvl2);

        // Show start opened
        $('.js-collapse-start-opened').find('.js-accordion-toggle').trigger('click');
	};

	var openAccordion = function(e) {
		var target = $(e.currentTarget),
			accordion = target.closest('.js-accordion-item');

		target.toggleClass('opened');
		accordion.toggleClass('opened');
		accordion.children('.js-collapse').slideToggle();
	};

	var openAccordionLvl2 = function(e) {
		var target = $(e.currentTarget),
			accordion = target.closest('.js-accordion-item');

		target.toggleClass('opened');
		target.toggleClass('closed');
		accordion.toggleClass('opened');
		accordion.children('.js-collapse').slideToggle();
	};

	$(document).ready(function() {
		init();
	});

})(jQuery);
